// 5D Autostacker Demo Configuration
// Hangar HGR-018 at KOPF (Miami Opa-Locka), 240x200x32ft, rotation 269.15°
// All IDs are fixed UUIDs — must match the SQL seed data

export const DEMO_CONFIG = {
  orgId: 'a555dac4-de7c-409f-9d00-d8c45615d875',
  locationId: 'aa5b92ce-91e8-441c-8e07-2c55fcfc7604',
  locationSlug: 'kopf',
  areaId: 'e93221ed-117a-4890-88a5-984af743fda2',
  unitId: '8d9e3398-12b0-44fc-b9ff-83cf1bb7358f',

  // Incoming hero aircraft
  heroAircraftId: 'c5c9daec-9a77-432c-aa99-d08f5aa0f9fd',  // Global 8000 (000022)
  heroAllocationId: 'a110c380-0009-4000-a000-000000000001',
  heroTransientStayId: 'd5a12380-0009-4000-a000-000000000001',
  heroClientName: 'JetWing Executive Aviation',

  // Pre-placed fleet allocation IDs (for reset)
  fleetAllocationIds: [
    'a110c380-0001-4000-a000-000000000001', // N82394BG Global 6000   – departs 06:00
    'a110c380-0002-4000-a000-000000000001', // 000018   King Air 350   – long stay
    'a110c380-0003-4000-a000-000000000001', // 000004   G450           – long stay
    'a110c380-0004-4000-a000-000000000001', // N12354YT Challenger 350 – departs 10:00
    'a110c380-0005-4000-a000-000000000001', // 020001   Citation Long  – long stay
    'a110c380-0006-4000-a000-000000000001', // 000001   Citation XLS+  – long stay
    'a110c380-0007-4000-a000-000000000001', // N98765B  Citation CJ4   – departs 14:00
    'a110c380-0008-4000-a000-000000000001', // 000024   Pilatus PC-12  – long stay
  ],
} as const

// Original positions snapshot for demo reset
// position: [x, y, z] in scene-space feet, rotation in degrees
// Positions calculated to avoid wall/aircraft collisions.
// Back wall X≈802, door X≈602, left wall Z≈-784, right wall Z≈-544.
// Aircraft rotation=90 means nose-in (nose toward +X/back wall).
export const DEMO_ORIGINAL_POSITIONS: Record<string, { position: [number, number, number]; rotation: number; status: string; presence: string; positionType: string }> = {
  // Back row (deepest) — noses within 10ft of back wall
  'a110c380-0001-4000-a000-000000000001': { position: [750, 0, -728], rotation: 90,  status: 'active',   presence: 'present',  positionType: 'hangar' }, // N82394BG Global 6000 (94×88ft) — left column back
  'a110c380-0002-4000-a000-000000000001': { position: [768, 0, -640], rotation: 90,  status: 'active',   presence: 'present',  positionType: 'hangar' }, // 000018   King Air 350 (58×48ft) — center column back
  'a110c380-0003-4000-a000-000000000001': { position: [755, 0, -593], rotation: 90,  status: 'active',   presence: 'present',  positionType: 'hangar' }, // 000004   G450 (78×74ft)          — right column back
  // Middle row — in front of back-row aircraft in same Z column
  'a110c380-0004-4000-a000-000000000001': { position: [665, 0, -724], rotation: 90,  status: 'active',   presence: 'present',  positionType: 'hangar' }, // N12354YT Challenger 350 (69×67ft) — left column mid (departs 10:00)
  'a110c380-0005-4000-a000-000000000001': { position: [711, 0, -614], rotation: 90,  status: 'active',   presence: 'present',  positionType: 'hangar' }, // 020001   Citation Long (69×73ft) — right column mid
  // Front row — closest to door, some aircraft tails may protrude through door opening
  'a110c380-0006-4000-a000-000000000001': { position: [600, 0, -660], rotation: 90,  status: 'active',   presence: 'present',  positionType: 'hangar' }, // 000001   Citation XLS+ (63×59ft) — center front
  'a110c380-0007-4000-a000-000000000001': { position: [662, 0, -650], rotation: 90,  status: 'active',   presence: 'present',  positionType: 'hangar' }, // N98765B  Citation CJ4 (51×46ft)  — center front (departs 14:00)
  'a110c380-0008-4000-a000-000000000001': { position: [645, 0, -548], rotation: 90,  status: 'active',   presence: 'present',  positionType: 'hangar' }, // 000024   Pilatus PC-12 (53×48ft)  — right front
  // Hero incoming — on ramp, 112ft from door (space for tow operations)
  'a110c380-0009-4000-a000-000000000001': { position: [490, 0, -666], rotation: 270, status: 'reserved', presence: 'expected', positionType: 'ramp'   }, // 000022   Global 8000 (104×111ft)
}
